module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/213.0aa83c54.png";